import { render, staticRenderFns } from "./ContributorListView.vue?vue&type=template&id=8bc4497c"
import script from "./ContributorListView.vue?vue&type=script&lang=js"
export * from "./ContributorListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports